(() => {
  if (window.DiggnBlackSaltGift) return;
  const variant = 40610148876377, campaign = '2026-10-18-gift-50', code = 'BLACKSALTGIFT50';
  const end = '2026-10-29T21:00:00Z';
  const owned = item => item.variant_id === variant && item.properties?._black_salt_offer === campaign;
  const eligible = cart => cart.items.some(i => i.variant_id !== variant && i.final_line_price > 0 && i.requires_shipping && !i.gift_card);
  const giftLines = cart => cart.items.filter(owned);
  const freeGift = cart => giftLines(cart).length === 1 && giftLines(cart)[0].quantity === 1 && giftLines(cart)[0].final_line_price === 0 && eligible(cart);
  const failure = reason => Object.assign(new Error(reason), { reason });
  const stable = value => value && typeof value === 'object' ? (Array.isArray(value) ? value.map(stable) : Object.fromEntries(Object.keys(value).sort().map(key => [key, stable(value[key])]))) : value;
  // Shopify's line key includes discount state. Compare merchandise and amounts instead.
  const purchasedLines = cart => cart.items.filter(i => !owned(i)).map(i => JSON.stringify(stable({
    variant: i.variant_id, plan: i.selling_plan_allocation?.selling_plan?.id || null,
    properties: i.properties || {}, components: i.item_components || [], quantity: i.quantity, price: i.final_line_price
  }))).sort().join('\n');
  async function remove(request) {
    let cart = await request('cart.js');
    for (const line of giftLines(cart)) cart = await request('cart/change.js', { id: line.key, quantity: 0 });
    cart = await request('cart.js');
    if (giftLines(cart).length) throw failure('rollbackError');
    // Remove only our code. Preserve codes the customer has entered, including inactive ones.
    const codes = cart.discount_codes || [];
    if (codes.some(d => d.code.toUpperCase() === code)) {
      await request('cart/update.js', { discount: codes.filter(d => d.code.toUpperCase() !== code).map(d => d.code).join(',') });
    }
    return cart;
  }
  async function accept(request, options) {
    if ((options.now ?? Date.now()) >= Date.parse(options.end)) throw failure('closed');
    const before = await request('cart.js');
    if (freeGift(before)) return before;
    if (before.items.some(i => i.variant_id === variant)) throw failure('error');
    if (!eligible(before)) throw failure('qualify');
    if ((before.discount_codes || []).some(d => d.code.toUpperCase() !== code) ||
      before.items.some(i => i.line_level_total_discount > 0) || (before.cart_level_discount_applications || []).some(d => d.target_type !== 'shipping_line')) throw failure('discountConflict');
    try {
      await request('cart/add.js', { items: [{ id: variant, quantity: 1, properties: {
        [options.expiryLabel]: options.expiryValue, _black_salt_offer: campaign, _black_salt_phase: 'gift_cart_50'
      } }] });
      await request('cart/update.js', { discount: code });
      const after = await request('cart.js');
      if (!freeGift(after)) throw failure('error');
      // Check that applying the gift has not changed purchased lines or their prices.
      if (purchasedLines(before) !== purchasedLines(after)) throw failure('discountConflict');
      return after;
    } catch (error) {
      try { await remove(request); } catch { throw failure('rollbackError'); }
      throw error;
    }
  }
  window.DiggnBlackSaltGift = { accept, remove, eligible, freeGift, owned, campaign, code, end };
  if (customElements.get('black-salt-cart-gift')) return;
  const root = () => window.Shopify?.routes?.root || '/';
  async function request(path, body) {
    const response = await fetch(root() + path, { method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: body ? { 'Content-Type': 'application/json' } : {}, body: body ? JSON.stringify(body) : undefined });
    if (!response.ok) throw failure('error');
    return response.json();
  }
  let pending = Promise.resolve(), busy = false;
  const run = action => { const result = pending.then(action); pending = result.catch(() => {}); return result; };
  const consent = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  function track(action, locale) {
    if (!consent()) return Promise.resolve();
    const event = { event: 'black_salt_gift_' + action, campaign, locale, surface: 'cart' };
    try { window.dataLayer?.push(event); window.Shopify?.analytics?.publish?.(event.event, { campaign, locale, surface: 'cart' }); } catch { /* Tracking cannot interrupt shopping. */ }
    const attributes = { bs_gift_campaign__: campaign, ['bs_gift_' + (action === 'view' ? 'exposed' : 'decision') + '__']: action === 'view' ? 'yes' : action };
    return run(() => request('cart/update.js', { attributes })).catch(() => {});
  }
  function choice(value) { try { if (value) sessionStorage.setItem(campaign + ':choice', value); return sessionStorage.getItem(campaign + ':choice'); } catch { return null; } }
  function blockCheckout(blocked) {
    document.querySelectorAll('#checkout,#CartDrawer-Checkout,[name="checkout"]').forEach(button => {
      if (blocked && !button.disabled) { button.dataset.bsGiftDisabled = 'true'; button.disabled = true; }
      if (!blocked && button.dataset.bsGiftDisabled) { button.disabled = false; delete button.dataset.bsGiftDisabled; }
    });
    const skipExpress = blocked || !!document.querySelector('[data-bs-gift-present]');
    document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach(el => {
      if (skipExpress && !el.hidden) { el.dataset.bsGiftHidden = 'true'; el.hidden = true; }
      if (!skipExpress && el.dataset.bsGiftHidden) { el.hidden = false; delete el.dataset.bsGiftHidden; }
    });
  }
  function guard() {
    blockCheckout(busy || !!document.querySelector('[data-bs-gift-unsafe]'));
    // The released pool is for accepted gifts. Do not reopen the normal product buy buttons.
    if (!document.querySelector('[data-bs-gift-active]')) return;
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      const giftSelected = Number(form.querySelector('[name="id"]')?.value) === variant;
      form.querySelectorAll('[name="add"],button[type="submit"]').forEach(button => {
        if (giftSelected && !button.disabled) { button.dataset.bsGiftOnlyDisabled = 'true'; button.disabled = true; }
        if (!giftSelected && button.dataset.bsGiftOnlyDisabled) { button.disabled = false; delete button.dataset.bsGiftOnlyDisabled; }
      });
      form.querySelectorAll('.shopify-payment-button').forEach(el => {
        if (giftSelected && !el.hidden) { el.dataset.bsGiftOnlyHidden = 'true'; el.hidden = true; }
        if (!giftSelected && el.dataset.bsGiftOnlyHidden) { el.hidden = false; delete el.dataset.bsGiftOnlyHidden; }
      });
    });
  }
  class BlackSaltCartGift extends HTMLElement {
    connectedCallback() {
      this.copy = JSON.parse(this.querySelector('[data-bs-gift-copy]').textContent);
      this.addEventListener('click', this.clickHandler = event => {
        const button = event.target.closest('[data-bs-gift-action]');
        if (button) this.act(button.dataset.bsGiftAction);
      });
      this.renderChoice();
      if (this.dataset.canOffer === 'true') {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(e => e.isIntersecting)) { track('view', this.dataset.locale); this.observer.disconnect(); }
        }, { threshold: 0.5 });
        this.observer.observe(this);
      }
      if (this.dataset.hasGift === 'true') this.expiryTimer = setTimeout(() => { this.setAttribute('data-bs-gift-unsafe', ''); this.message('closed'); guard(); }, Math.min(2147483647, Math.max(0, Date.parse(end) - Date.now())));
      guard();
    }
    disconnectedCallback() { this.removeEventListener('click', this.clickHandler); this.observer?.disconnect(); clearTimeout(this.expiryTimer); }
    message(key) { const status = this.querySelector('[data-bs-gift-status]'); status.textContent = this.copy[key] || this.copy.error; status.hidden = false; }
    renderChoice() {
      const declined = choice() === 'declined';
      this.querySelectorAll('[data-bs-gift-action="accept"]').forEach(b => b.textContent = this.copy[declined ? 'reconsider' : 'accept']);
      this.querySelectorAll('[data-bs-gift-action="decline"]').forEach(b => b.hidden = declined);
      if (declined && this.dataset.hasGift !== 'true') this.message('declined');
    }
    async act(action) {
      if (busy) return;
      if (action === 'decline') { choice('declined'); this.renderChoice(); await track('declined', this.dataset.locale); return; }
      busy = true; guard(); this.setAttribute('aria-busy', 'true');
      this.querySelectorAll('button').forEach(b => b.disabled = true);
      try {
        if (action === 'remove') { await run(() => remove(request)); choice('removed'); await track('removed', this.dataset.locale); }
        else {
          await run(() => accept(request, { end, expiryLabel: this.copy.expiryLabel, expiryValue: this.copy.expiryValue }));
          choice('accepted'); await track('accepted', this.dataset.locale);
        }
        location.assign(root() + 'cart');
      } catch (error) {
        this.message(error.reason || 'error');
        if (error.reason === 'rollbackError') { this.setAttribute('data-bs-gift-unsafe', ''); this.dataset.hasGift = 'true'; this.querySelector('[data-bs-gift-action="remove"]').hidden = false; }
      } finally {
        busy = false; this.removeAttribute('aria-busy'); this.querySelectorAll('button').forEach(b => b.disabled = false); guard();
      }
    }
  }
  customElements.define('black-salt-cart-gift', BlackSaltCartGift);
  new MutationObserver(guard).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('change', guard);
  // Re-check immediately before the normal cart checkout; stale prices never show as a confirmed gift.
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (document.querySelector('[data-bs-gift-active]') && form.matches('form[action*="/cart/add"]') && Number(form.querySelector('[name="id"]')?.value) === variant) { event.preventDefault(); return; }
    if (!form.matches('form[action$="/cart"]') || !document.querySelector('[data-bs-gift-present]') || form.dataset.bsGiftChecked === 'true') return;
    event.preventDefault();
    if (busy || document.querySelector('[data-bs-gift-unsafe]')) return;
    const submitter = event.submitter;
    try {
      const cart = await run(() => request('cart.js'));
      if (Date.now() >= Date.parse(end) || (giftLines(cart).length && !freeGift(cart))) { location.reload(); return; }
      form.dataset.bsGiftChecked = 'true'; form.requestSubmit(submitter); delete form.dataset.bsGiftChecked;
    } catch { document.querySelector('black-salt-cart-gift')?.message('error'); }
  }, true);
  guard();
})();
